// OilList.js - Complete with QR Code Print for 50mm x 25mm labels
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useAuth } from '../module_roots/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "./Styles/FormList.css";
import {
    faEdit, faTrash, faSave, faSearch, faRefresh, faSpinner, faEye, faTachometerAlt,
    faExclamationTriangle, faCheckCircle, faTimes, faChevronLeft,
    faChevronRight, faFilePdf, faCalendar, faUser, faStore, faPhone,
    faEnvelope, faMapMarkerAlt, faTag, faExchangeAlt, faChevronDown,
    faExpand, faCompress, faArrowsAlt, faMinus, faPlus, faFilter, faEyeSlash,
    faTruck, faBuilding, faGlobe, faUserTag, faStickyNote, faExternalLinkAlt,
    faWrench, faCar, faClock, faHourglassHalf, faCheck, faBan, faMoneyBill,
    faCreditCard, faUsers, faBox, faReceipt, faChartLine, faCalculator,
    faPercent, faInfoCircle, faOilCan, faGasPump, faRoad, faCalendarCheck,
    faPrint, faQrcode
} from '@fortawesome/free-solid-svg-icons';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import QRCode from 'qrcode';

// ============================================
// SHARED TRANSLATOR FOR OIL LIST
// ============================================
const createOilListTranslator = () => {
    let cache = new Map();

    const loadFromCache = () => {
        try {
            const cached = localStorage.getItem('ourzest_translations_oil');
            if (cached) {
                const parsed = JSON.parse(cached);
                Object.entries(parsed).forEach(([key, value]) => {
                    cache.set(key, value);
                });
            }
        } catch (e) { }
    };

    const saveToCache = () => {
        try {
            const cacheObj = {};
            cache.forEach((value, key) => {
                cacheObj[key] = value;
            });
            localStorage.setItem('ourzest_translations_oil', JSON.stringify(cacheObj));
        } catch (e) { }
    };

    const translateAPI = async (text, targetLang) => {
        if (targetLang === 'en') return text;

        const dict = {
            'ur': {
                'Oil Records List': 'تیل کے ریکارڈز کی فہرست',
                'All oil records are below': 'تمام تیل کے ریکارڈز نیچے ہیں',
                'Oil Record Number': 'تیل ریکارڈ نمبر',
                'Customer Name': 'گاہک کا نام',
                'Customer Phone': 'گاہک کا فون',
                'Car Model': 'کار ماڈل',
                'Number Plate': 'نمبر پلیٹ',
                'Oil Change Date': 'تیل تبدیل کرنے کی تاریخ',
                'Mobo Oil Millage': 'موبائل آئل مائلیج',
                'Next Change': 'اگلی تبدیلی',
                'Odometer Reading': 'اوڈومیٹر ریڈنگ',
                'Total Amount': 'کل رقم',
                'Paid Amount': 'ادا کردہ رقم',
                'Balance': 'بقایا',
                'Status': 'حالت',
                'Payment Status': 'ادائیگی کی حالت',
                'Actions': 'اعمال',
                'Added By': 'شامل کرنے والا',
                'Search oil records...': 'تیل کے ریکارڈز تلاش کریں...',
                'Refresh': 'ریفریش کریں',
                'Export PDF': 'پی ڈی ایف ایکسپورٹ کریں',
                'Edit': 'ترمیم کریں',
                'Delete': 'حذف کریں',
                'Print': 'پرنٹ کریں',
                'QR Code': 'کیو آر کوڈ',
                'Close': 'بند کریں',
                'Save Changes': 'تبدیلیاں محفوظ کریں',
                'Cancel': 'منسوخ کریں',
                'Success': 'کامیابی',
                'Error': 'خرابی',
                'Warning': 'انتباہ',
                'Showing': 'دکھا رہا ہے',
                'of': 'میں سے',
                'Previous': 'پچھلا',
                'Next': 'اگلا',
                'All': 'سب',
                'Oil Record Details': 'تیل ریکارڈ کی تفصیلات',
                'Contact Information': 'رابطہ کی معلومات',
                'Vehicle Information': 'گاڑی کی معلومات',
                'Switch Shop': 'شاپ تبدیل کریں',
                'No shop selected': 'کوئی شاپ منتخب نہیں',
                'Please select a shop to view oil records': 'براہ کرم تیل کے ریکارڈز دیکھنے کے لیے شاپ منتخب کریں',
                'S.No': 'نمبر',
                'Oil Records': 'تیل کے ریکارڈز',
                'Shop': 'شاپ',
                'View': 'دیکھیں',
                'Update Oil Record': 'تیل ریکارڈ اپڈیٹ کریں',
                'Updating...': 'اپڈیٹ ہو رہا ہے...',
                'Oil record updated successfully': 'تیل ریکارڈ کامیابی سے اپڈیٹ ہو گیا',
                'Error updating oil record': 'تیل ریکارڈ اپڈیٹ کرنے میں خرابی',
                'Confirm Delete': 'حذف کرنے کی تصدیق',
                'Yes, Delete': 'ہاں، حذف کریں',
                'No, Cancel': 'نہیں، منسوخ کریں',
                'Portrait': 'عمودی',
                'Landscape': 'افقی',
                'A4': 'A4',
                'Letter': 'لیٹر',
                'Legal': 'لیگل',
                'A5': 'A5',
                'Oil Report': 'تیل رپورٹ',
                'Oil Directory': 'تیل ڈائریکٹری',
                'Total Oil Records': 'کل تیل ریکارڈز',
                'Generated': 'تیار کردہ',
                'Report ID': 'رپورٹ آئی ڈی',
                'Generated by': 'تیار کردہ بذریعہ',
                'Shop Code': 'شاپ کوڈ',
                'FILTERS APPLIED': 'فلٹرز لاگو ہیں',
                'Search': 'تلاش کریں',
                'From': 'سے',
                'To': 'تک',
                'Page': 'صفحہ',
                'Pending': 'زیر التواء',
                'In Progress': 'جاری',
                'Completed': 'مکمل',
                'Cancelled': 'منسوخ',
                'Paid': 'ادا شدہ',
                'Partial': 'جزوی',
                'Unpaid': 'غیر ادا شدہ',
                'Financial Summary': 'مالی خلاصہ',
                'Total Revenue': 'کل آمدنی',
                'Total Paid': 'کل ادائیگی',
                'Outstanding': 'بقایا',
                'Subtotal': 'ذیلی کل',
                'Tax': 'ٹیکس',
                'Discount': 'ڈسکاؤنٹ',
                'Grand Total': 'کل مجموعہ',
                'Payment Method': 'ادائیگی کا طریقہ',
                'Cash': 'نقد',
                'Card': 'کارڈ',
                'UPI': 'یوپی آئی',
                'Notes': 'نوٹس',
                'Oil Change Receipt': 'آئل چینج رسید',
                'Products Total': 'مصنوعات کا کل',
                'Product Name': 'مصنوعات کا نام',
                'Quantity': 'مقدار',
                'Price': 'قیمت',
                'Total': 'کل',
                'Oil Type': 'تیل کی قسم',
                'Oil Brand': 'تیل کا برانڈ',
                'Oil Quantity': 'تیل کی مقدار',
                'Filter Type': 'فلٹر کی قسم',
                'Value': 'قیمت',
                'Oil Details': 'تیل کی تفصیلات',
                'Scan QR to view details': 'تفصیلات دیکھنے کے لیے QR اسکین کریں'
            },
            'ar': {
                'QR Code': 'رمز الاستجابة السريعة',
                'Scan QR to view details': 'امسح رمز الاستجابة السريعة لعرض التفاصيل'
            },
            'es': {
                'QR Code': 'Código QR',
                'Scan QR to view details': 'Escanee el código QR para ver los detalles'
            }
        };

        if (dict[targetLang] && dict[targetLang][text]) {
            return dict[targetLang][text];
        }

        try {
            const response = await fetch('https://translate.argosopentech.com/translate', {
                method: 'POST',
                body: JSON.stringify({ q: text, source: 'en', target: targetLang }),
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.ok) {
                const data = await response.json();
                return data.translatedText;
            }
        } catch (e) { }

        try {
            const response = await fetch(
                `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=en|${targetLang}`
            );
            if (response.ok) {
                const data = await response.json();
                return data.responseData.translatedText;
            }
        } catch (e) { }

        return text;
    };

    const translateText = async (text, targetLang) => {
        const cacheKey = `${text}_${targetLang}`;
        if (cache.has(cacheKey)) {
            return cache.get(cacheKey);
        }
        const translated = await translateAPI(text, targetLang);
        cache.set(cacheKey, translated);
        saveToCache();
        return translated;
    };

    const defaultTexts = {
        oilList: 'Oil Records List',
        formDetails: 'All oil records are below',
        oilRecords: 'Oil Records',
        shopName: 'Shop',
        noShopSelected: 'No shop selected. Please select a shop first.',
        switchShop: 'Switch Shop',
        loadingShops: 'Loading shops...',
        noShops: 'No shops available',
        current: 'Current',
        searchPlaceholder: 'Search oil records...',
        refresh: 'Refresh',
        loadingUserData: 'Loading your oil record data...',
        selectShop: 'Please select a shop to view oil records',
        oilNumber: 'Oil Record No',
        customerName: 'Customer',
        customerPhone: 'Phone',
        carModel: 'Car Model',
        numberPlate: 'Number Plate',
        oilDate: 'Date',
        odometerReading: 'Odometer',
        moboOilMillage: 'Mobo Millage',
        nextChange: 'Next Change',
        totalAmount: 'Total',
        paidAmount: 'Paid',
        balance: 'Balance',
        status: 'Status',
        paymentStatus: 'Payment',
        actions: 'Actions',
        addedBy: 'Added By',
        edit: 'Edit',
        delete: 'Delete',
        print: 'Print',
        qrCode: 'QR Code',
        serialNo: 'S.No',
        showing: 'Showing',
        of: 'of',
        previous: 'Previous',
        next: 'Next',
        all: 'All',
        searchFilter: 'Search',
        statusFilter: 'Status',
        paymentFilter: 'Payment Status',
        startDate: 'Start Date',
        endDate: 'End Date',
        exportToPDF: 'Export PDF',
        orientation: 'Orientation',
        portrait: 'Portrait',
        landscape: 'Landscape',
        pageSize: 'Page Size',
        a4: 'A4',
        letter: 'Letter',
        legal: 'Legal',
        a5: 'A5',
        oilDetails: 'Oil Record Details',
        contactInfo: 'Contact Information',
        vehicleInfo: 'Vehicle Information',
        editOilRecord: 'Edit Oil Record',
        saveChanges: 'Save Changes',
        cancel: 'Cancel',
        confirmDelete: 'Confirm Delete',
        deleteMessage: 'Are you sure you want to delete this oil record?',
        deleteWarning: 'This action cannot be undone.',
        yesDelete: 'Yes, Delete',
        noCancel: 'No, Cancel',
        success: 'Success',
        error: 'Error',
        warning: 'Warning',
        close: 'Close',
        oilReport: 'Oil Report',
        oilDirectory: 'Oil Directory',
        totalOilRecords: 'Total Oil Records',
        generated: 'Generated',
        reportId: 'Report ID',
        generatedBy: 'Generated by',
        shopCode: 'Shop Code',
        filtersApplied: 'FILTERS APPLIED',
        search: 'Search',
        from: 'From',
        to: 'To',
        page: 'Page',
        pending: 'Pending',
        inProgress: 'In Progress',
        completed: 'Completed',
        cancelled: 'Cancelled',
        paid: 'Paid',
        partial: 'Partial',
        unpaid: 'Unpaid',
        subtotal: 'Subtotal',
        tax: 'Tax',
        discount: 'Discount',
        grandTotal: 'Grand Total',
        paymentMethod: 'Payment Method',
        cash: 'Cash',
        card: 'Card',
        upi: 'UPI',
        notes: 'Notes',
        financialSummary: 'Financial Summary',
        totalRevenue: 'Total Revenue',
        totalPaid: 'Total Paid',
        outstanding: 'Outstanding',
        oilChangeReceipt: 'Oil Change Receipt',
        productsTotal: 'Products Total',
        productName: 'Product',
        quantity: 'Qty',
        price: 'Price',
        total: 'Total',
        oilType: 'Oil Type',
        oilBrand: 'Oil Brand',
        oilQuantity: 'Oil Quantity',
        filterType: 'Filter Type',
        value: 'Value',
        scanQRToView: 'Scan QR to view details'
    };

    const getTranslations = async (lang) => {
        if (lang === 'en') {
            return defaultTexts;
        }

        const translations = {};
        const promises = [];

        Object.keys(defaultTexts).forEach(key => {
            const cacheKey = `${defaultTexts[key]}_${lang}`;
            if (cache.has(cacheKey)) {
                translations[key] = cache.get(cacheKey);
            } else {
                promises.push(
                    translateText(defaultTexts[key], lang).then(translated => {
                        translations[key] = translated;
                    })
                );
            }
        });

        if (promises.length > 0) {
            await Promise.all(promises);
            saveToCache();
        }

        return translations;
    };

    loadFromCache();

    return {
        getTranslations,
        translateText
    };
};

const oilListTranslator = createOilListTranslator();

// Toast Notification Component
const ToastNotification = ({ toast, setToast, translations }) => {
    const getIconForType = (type) => {
        switch (type) {
            case 'success': return faCheckCircle;
            case 'error': return faExclamationTriangle;
            case 'warning': return faExclamationTriangle;
            default: return faCheckCircle;
        }
    };

    const getTitleForType = (type) => {
        switch (type) {
            case 'success': return translations.success || 'Success';
            case 'error': return translations.error || 'Error';
            case 'warning': return translations.warning || 'Warning';
            default: return '';
        }
    };

    if (!toast.show) return null;

    return (
        <div className={`ozui_toast-notification ${toast.type}`}>
            <div className="ozui_toast-content">
                <div className="ozui_toast-icon">
                    <FontAwesomeIcon icon={getIconForType(toast.type)} />
                </div>
                <div className="ozui_toast-text">
                    <div className="ozui_toast-title">{getTitleForType(toast.type)}</div>
                    <div className="ozui_toast-message">{toast.message}</div>
                </div>
                <button className="ozui_toast-close" onClick={() => setToast(prev => ({ ...prev, show: false }))}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
        </div>
    );
};


// Shop Selector Modal Component
const ShopSelectorModal = ({ isOpen, onClose, shops, currentShop, onSelectShop, translations, loading }) => {
    if (!isOpen) return null;

    return (
        <div className="ozlistui-modal-overlay" onClick={onClose}>
            <div className="ozlistui-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="ozlistui-modal-header">
                    <h3>{translations.switchShop || 'Switch Shop'}</h3>
                    <button className="ozlistui-close-btn" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="ozlistui-modal-body">
                    {loading ? (
                        <div className="ozlistui-loading-shops">
                            <div className="ozlistui-loading-spinner-small"></div>
                            <p>{translations.loadingShops || 'Loading shops...'}</p>
                        </div>
                    ) : shops.length === 0 ? (
                        <div className="ozlistui-no-shops">
                            <p>{translations.noShops || 'No shops available'}</p>
                        </div>
                    ) : (
                        <div className="ozlistui-shop-list">
                            {shops.map((shop) => (
                                <div
                                    key={shop.shop_id}
                                    className={`ozlistui-shop-item ${currentShop?.shop_id === shop.shop_id ? 'ozlistui-active' : ''}`}
                                    onClick={() => onSelectShop(shop)}
                                >
                                    <div className="ozlistui-shop-item-icon">
                                        <FontAwesomeIcon icon={faStore} />
                                    </div>
                                    <div className="ozlistui-shop-item-details">
                                        <div className="ozlistui-shop-item-name">{shop.shop_name}</div>
                                        <div className="ozlistui-shop-item-code">{shop.shop_code || `ID: ${shop.shop_id}`}</div>
                                    </div>
                                    {currentShop?.shop_id === shop.shop_id && (
                                        <div className="ozlistui-shop-item-current">
                                            <FontAwesomeIcon icon={faCheckCircle} />
                                            <span>{translations.current || 'Current'}</span>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

// Custom Dropdown Component
const CustomDropdown = ({ label, icon, value, onChange, options, placeholder, translations, disabled = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const wrapperRef = useRef(null);

    const selectedOption = options.find(opt => opt.value === value);
    const displayValue = selectedOption?.label || '';

    useEffect(() => {
        setSearchTerm(displayValue);
    }, [displayValue]);

    const filteredOptions = searchTerm.trim() === ''
        ? options
        : options.filter(opt =>
            opt.label.toLowerCase().includes(searchTerm.toLowerCase())
        );

    const handleSelect = (option) => {
        onChange(option.value);
        setSearchTerm(option.label);
        setIsOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="ozlistui-custom-dropdown-wrapper" ref={wrapperRef}>
            <div className="ozlistui-custom-input-wrapper">
                <input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setIsOpen(true);
                        if (!options.find(opt => opt.label.toLowerCase() === e.target.value.toLowerCase())) {
                            onChange('');
                        }
                    }}
                    onFocus={() => setIsOpen(true)}
                    placeholder=" "
                    disabled={disabled}
                    autoComplete="off"
                />
                <label>
                    {icon && <FontAwesomeIcon icon={icon} />}
                    {label}
                </label>
                <FontAwesomeIcon icon={faChevronDown} className="ozlistui-custom-dropdown-arrow" />
            </div>

            {isOpen && (
                <div className="ozlistui-custom-dropdown-menu">
                    {filteredOptions.length > 0 ? (
                        filteredOptions.map(opt => (
                            <div
                                key={opt.value}
                                className={`ozlistui-custom-dropdown-option ${value === opt.value ? 'ozlistui-selected' : ''}`}
                                onClick={() => handleSelect(opt)}
                            >
                                {opt.label}
                            </div>
                        ))
                    ) : (
                        <div className="ozlistui-custom-dropdown-empty">
                            No options found
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

// Main Component
const OilList = () => {
    const { user, currentShop, switchShop, getShopsForSwitch } = useAuth();
    const [oilRecords, setOilRecords] = useState([]);
    const [filteredOilRecords, setFilteredOilRecords] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pdfLoading, setPdfLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedOilRecord, setSelectedOilRecord] = useState(null);
    const [showViewModal, setShowViewModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [oilRecordToDelete, setOilRecordToDelete] = useState(null);
    const [editLoading, setEditLoading] = useState(false);
    const [showFilters, setShowFilters] = useState(false);

    // PDF Options State
    const [pdfOrientation, setPdfOrientation] = useState('landscape');
    const [pdfPageSize, setPdfPageSize] = useState('a4');
    const [pdfPageRange, setPdfPageRange] = useState('all');
    const [pdfStartPage, setPdfStartPage] = useState(1);
    const [pdfEndPage, setPdfEndPage] = useState(1);

    // Shop selector state
    const [showShopSelector, setShowShopSelector] = useState(false);
    const [availableShops, setAvailableShops] = useState([]);
    const [loadingShops, setLoadingShops] = useState(false);

    // Business info state
    const [localBusinessInfo, setLocalBusinessInfo] = useState({
        businessname: '',
        businessaddress: '',
        phonenumber: '',
        gst_number: '',
        email: '',
        bussinesslogo: '',
        bussinesslogo_url: ''
    });

    // Modal drag and resize state
    const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });
    const [modalSize, setModalSize] = useState({ width: 650, height: 'auto' });
    const [isDragging, setIsDragging] = useState(false);
    const [isResizing, setIsResizing] = useState(false);
    const [currentWidthMode, setCurrentWidthMode] = useState('wide');
    const [isModalInitialized, setIsModalInitialized] = useState(false);

    const dragStart = useRef({ x: 0, y: 0 });
    const modalRef = useRef(null);
    const resizeType = useRef(null);
    const resizeStart = useRef({ x: 0, y: 0, width: 0, height: 0, left: 0, top: 0 });

    const widthModes = {
        narrow: { width: 400, label: 'Narrow', icon: faMinus },
        medium: { width: 650, label: 'Medium', icon: faArrowsAlt },
        wide: { width: 850, label: 'Wide', icon: faPlus },
        full: { width: '95vw', label: 'Full Width', icon: faExpand },
        fullscreen: { width: '98vw', label: 'Full Screen', icon: faCompress }
    };

    // Filter states
    const [statusFilter, setStatusFilter] = useState('');
    const [paymentFilter, setPaymentFilter] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    // Theme, Dark Mode, Language State
    const [currentLanguage, setCurrentLanguage] = useState(() => {
        return localStorage.getItem('ourzest_language') || 'en';
    });
    const [currentTheme, setCurrentTheme] = useState(() => {
        return localStorage.getItem('ourzest_theme') || '#6366f1';
    });
    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem('ourzest_darkMode') === 'true';
    });
    const [translations, setTranslations] = useState({});

    // Toast state
    const [toast, setToast] = useState({
        show: false,
        type: '',
        message: '',
        progress: 100,
        timeLeft: 3
    });

    const toastTimerRef = useRef(null);
    const isMountedRef = useRef(true);

    // Edit form state
    const [editFormData, setEditFormData] = useState({
        oil_number: '',
        customer_name: '',
        customer_phone: '',
        car_model: '',
        car_number_plate: '',
        odometer_reading: '',
        mobo_oil_millage: '',
        next_change: '',
        date: '',
        total_amount: '',
        paid_amount: '',
        status: 'pending',
        payment_status: 'unpaid',
        payment_method: 'cash',
        notes: ''
    });
    const [editFormErrors, setEditFormErrors] = useState({});

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(20);

    const API_BASE = 'https://ourzestapp.online/oz_backend/mechanics_module';
    const OIL_API = `${API_BASE}/mechanics_mobchange.php`;

    const escapeHtml = (text) => {
        if (!text) return '';
        return String(text).replace(/[&<>]/g, function (m) {
            if (m === '&') return '&amp;';
            if (m === '<') return '&lt;';
            if (m === '>') return '&gt;';
            return m;
        });
    };

    const statusOptions = useMemo(() => [
        { value: '', label: translations.all || 'All' },
        { value: 'pending', label: translations.pending || 'Pending' },
        { value: 'in_progress', label: translations.inProgress || 'In Progress' },
        { value: 'completed', label: translations.completed || 'Completed' },
        { value: 'cancelled', label: translations.cancelled || 'Cancelled' }
    ], [translations]);

    const paymentOptions = useMemo(() => [
        { value: '', label: translations.all || 'All' },
        { value: 'paid', label: translations.paid || 'Paid' },
        { value: 'partial', label: translations.partial || 'Partial' },
        { value: 'unpaid', label: translations.unpaid || 'Unpaid' }
    ], [translations]);

    const pdfOrientationOptions = useMemo(() => [
        { value: 'portrait', label: translations.portrait || 'Portrait' },
        { value: 'landscape', label: translations.landscape || 'Landscape' }
    ], [translations]);

    const pdfPageSizeOptions = useMemo(() => [
        { value: 'a4', label: translations.a4 || 'A4' },
        { value: 'letter', label: translations.letter || 'Letter' },
        { value: 'legal', label: translations.legal || 'Legal' },
        { value: 'a5', label: translations.a5 || 'A5' }
    ], [translations]);

    const showToast = useCallback((type, message) => {
        if (toastTimerRef.current) clearInterval(toastTimerRef.current);
        setToast({ show: true, type, message, progress: 100, timeLeft: 3 });
        let timeLeft = 3;
        const timer = setInterval(() => {
            timeLeft -= 0.1;
            const progress = (timeLeft / 3) * 100;
            setToast(prev => ({ ...prev, progress, timeLeft: parseFloat(timeLeft.toFixed(1)) }));
            if (timeLeft <= 0) {
                clearInterval(timer);
                setToast(prev => ({ ...prev, show: false }));
            }
        }, 100);
        toastTimerRef.current = timer;
    }, []);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
            if (toastTimerRef.current) clearInterval(toastTimerRef.current);
        };
    }, []);

    // Fetch business info
    const fetchBusinessInfo = useCallback(async () => {
        if (!user || !user.username) return;
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/root_users.php?action=get_business_info&username=' + encodeURIComponent(user.username), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                credentials: 'include'
            });
            const data = await response.json();
            if (isMountedRef.current && data.status === 'success') {
                setLocalBusinessInfo({
                    businessname: data.businessname || '',
                    businessaddress: data.businessaddress || '',
                    phonenumber: data.phonenumber || '',
                    gst_number: data.gst_number || '',
                    email: data.email || '',
                    bussinesslogo: data.bussinesslogo || '',
                    bussinesslogo_url: data.bussinesslogo_url || ''
                });
            } else {
                setLocalBusinessInfo({
                    businessname: user.business_name || user.fullname || '',
                    businessaddress: user.business_address || '',
                    phonenumber: user.phonenumber || '',
                    gst_number: user.gst_number || '',
                    email: user.email || '',
                    bussinesslogo: user.bussinesslogo || '',
                    bussinesslogo_url: user.bussinesslogo_url || ''
                });
            }
        } catch (error) {
            console.error('Error fetching business info:', error);
            setLocalBusinessInfo({
                businessname: user.business_name || user.fullname || '',
                businessaddress: user.business_address || '',
                phonenumber: user.phonenumber || '',
                gst_number: user.gst_number || '',
                email: user.email || '',
                bussinesslogo: user.bussinesslogo || '',
                bussinesslogo_url: user.bussinesslogo_url || ''
            });
        }
    }, [user]);

    useEffect(() => {
        fetchBusinessInfo();
    }, [fetchBusinessInfo]);

    // Theme, Dark Mode, Language sync effects (same as before)
    useEffect(() => {
        const applyTheme = (color) => {
            if (!color || !/^#[0-9A-F]{6}$/i.test(color)) color = '#6366f1';
            document.documentElement.style.setProperty('--ozlistui-primary', color);
            document.documentElement.style.setProperty('--ozlistui-primary-dark', color);
            document.documentElement.style.setProperty('--ozlistui-primary-light', color);
            setCurrentTheme(color);
        };

        applyTheme(currentTheme);

        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_theme') {
                const newTheme = e.newValue || '#6366f1';
                applyTheme(newTheme);
            }
        };

        const handleThemeChanged = (event) => {
            if (event.detail && event.detail.theme) {
                applyTheme(event.detail.theme);
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('themeChanged', handleThemeChanged);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('themeChanged', handleThemeChanged);
        };
    }, [currentTheme]);

    useEffect(() => {
        const syncDarkMode = () => {
            const isDark = localStorage.getItem('ourzest_darkMode') === 'true';
            setDarkMode(isDark);
            const container = document.querySelector('.ozlistui-container');
            if (container) {
                if (isDark) {
                    container.classList.add('ozlistui-dark');
                } else {
                    container.classList.remove('ozlistui-dark');
                }
            }
            if (isDark) {
                document.body.classList.add('ozlistui-dark');
                document.documentElement.classList.add('ozlistui-dark');
            } else {
                document.body.classList.remove('ozlistui-dark');
                document.documentElement.classList.remove('ozlistui-dark');
            }
        };

        syncDarkMode();

        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_darkMode') {
                syncDarkMode();
            }
        };

        const handleDarkModeToggle = (event) => {
            if (event.detail) {
                const isDark = event.detail.darkMode;
                setDarkMode(isDark);
                const container = document.querySelector('.ozlistui-container');
                if (container) {
                    if (isDark) {
                        container.classList.add('ozlistui-dark');
                    } else {
                        container.classList.remove('ozlistui-dark');
                    }
                }
                if (isDark) {
                    document.body.classList.add('ozlistui-dark');
                    document.documentElement.classList.add('ozlistui-dark');
                } else {
                    document.body.classList.remove('ozlistui-dark');
                    document.documentElement.classList.remove('ozlistui-dark');
                }
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('darkModeToggled', handleDarkModeToggle);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('darkModeToggled', handleDarkModeToggle);
        };
    }, []);

    useEffect(() => {
        const loadTranslations = async (lang) => {
            const trans = await oilListTranslator.getTranslations(lang);
            setTranslations(trans);
        };

        const handleLanguageChange = () => {
            const lang = localStorage.getItem('ourzest_language') || 'en';
            if (lang !== currentLanguage) {
                setCurrentLanguage(lang);
                loadTranslations(lang);
            }
        };

        const handleCustomLanguageChange = (event) => {
            if (event.detail && event.detail.language) {
                const newLang = event.detail.language;
                if (newLang !== currentLanguage) {
                    setCurrentLanguage(newLang);
                    loadTranslations(newLang);
                }
            }
        };

        loadTranslations(currentLanguage);

        window.addEventListener('storage', handleLanguageChange);
        window.addEventListener('languageChanged', handleCustomLanguageChange);

        return () => {
            window.removeEventListener('storage', handleLanguageChange);
            window.removeEventListener('languageChanged', handleCustomLanguageChange);
        };
    }, [currentLanguage]);

    useEffect(() => {
        const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';
        const container = document.querySelector('.ozlistui-container');

        if (container) {
            if (isRTL) {
                container.classList.add('ozlistui-rtl');
                container.classList.remove('ozlistui-ltr');
            } else {
                container.classList.add('ozlistui-ltr');
                container.classList.remove('ozlistui-rtl');
            }
        }

        if (isRTL) {
            document.documentElement.dir = 'rtl';
            document.body.dir = 'rtl';
        } else {
            document.documentElement.dir = 'ltr';
            document.body.dir = 'ltr';
        }
    }, [currentLanguage]);

    // Center modal function
    const centerModal = useCallback(() => {
        if (!modalRef.current) return;
        const rect = modalRef.current.getBoundingClientRect();
        const left = (window.innerWidth - rect.width) / 2;
        const top = (window.innerHeight - rect.height) / 2;
        modalRef.current.style.left = `${Math.max(0, left)}px`;
        modalRef.current.style.top = `${Math.max(0, top)}px`;
        modalRef.current.style.transform = 'none';
        setModalPosition({ x: Math.max(0, left), y: Math.max(0, top) });
    }, []);

    const setWidthMode = useCallback((mode) => {
        if (!modalRef.current) return;
        setCurrentWidthMode(mode);
        const widthValue = widthModes[mode].width;
        if (mode === 'fullscreen') {
            modalRef.current.style.width = '98vw';
            modalRef.current.style.height = '90vh';
        } else {
            modalRef.current.style.width = typeof widthValue === 'number' ? `${widthValue}px` : widthValue;
            modalRef.current.style.height = 'auto';
        }
        setModalSize({ width: modalRef.current.offsetWidth, height: modalRef.current.offsetHeight });
        setTimeout(() => centerModal(), 10);
    }, [widthModes, centerModal]);

    const startDrag = useCallback((e) => {
        if (!modalRef.current) return;
        if (e.target.closest('button, input, select, textarea, a, .ozlistui-width-btn, .ozlistui-close-btn')) return;
        e.preventDefault();
        setIsDragging(true);
        const rect = modalRef.current.getBoundingClientRect();
        dragStart.current = { x: e.clientX - rect.left, y: e.clientY - rect.top };
        modalRef.current.style.transition = 'none';
    }, []);

    const startResize = useCallback((e, type) => {
        e.preventDefault();
        e.stopPropagation();
        if (!modalRef.current) return;
        setIsResizing(true);
        resizeType.current = type;
        const rect = modalRef.current.getBoundingClientRect();
        resizeStart.current = {
            x: e.clientX, y: e.clientY,
            width: rect.width, height: rect.height,
            left: rect.left, top: rect.top,
            minWidth: 350, minHeight: 400,
            maxWidth: window.innerWidth - 40, maxHeight: window.innerHeight - 40
        };
        modalRef.current.style.transition = 'none';
    }, []);

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (isDragging && modalRef.current) {
                let newLeft = e.clientX - dragStart.current.x;
                let newTop = e.clientY - dragStart.current.y;
                const rect = modalRef.current.getBoundingClientRect();
                newLeft = Math.max(0, Math.min(newLeft, window.innerWidth - rect.width));
                newTop = Math.max(0, Math.min(newTop, window.innerHeight - rect.height));
                modalRef.current.style.left = `${newLeft}px`;
                modalRef.current.style.top = `${newTop}px`;
                modalRef.current.style.transform = 'none';
                setModalPosition({ x: newLeft, y: newTop });
            }

            if (isResizing && modalRef.current && resizeType.current) {
                let newWidth = resizeStart.current.width;
                let newHeight = resizeStart.current.height;
                let newLeft = resizeStart.current.left;
                let newTop = resizeStart.current.top;
                const deltaX = e.clientX - resizeStart.current.x;
                const deltaY = e.clientY - resizeStart.current.y;

                switch (resizeType.current) {
                    case 'e': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width + deltaX)); break;
                    case 'w': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width - deltaX)); newLeft = resizeStart.current.left + (resizeStart.current.width - newWidth); break;
                    case 's': newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height + deltaY)); break;
                    case 'n': newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height - deltaY)); newTop = resizeStart.current.top + (resizeStart.current.height - newHeight); break;
                    case 'ne': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width + deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height - deltaY)); newTop = resizeStart.current.top + (resizeStart.current.height - newHeight); break;
                    case 'nw': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width - deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height - deltaY)); newLeft = resizeStart.current.left + (resizeStart.current.width - newWidth); newTop = resizeStart.current.top + (resizeStart.current.height - newHeight); break;
                    case 'se': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width + deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height + deltaY)); break;
                    case 'sw': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width - deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height + deltaY)); newLeft = resizeStart.current.left + (resizeStart.current.width - newWidth); break;
                }
                modalRef.current.style.width = `${newWidth}px`;
                modalRef.current.style.height = `${newHeight}px`;
                modalRef.current.style.left = `${newLeft}px`;
                modalRef.current.style.top = `${newTop}px`;
                setModalSize({ width: newWidth, height: newHeight });
                setModalPosition({ x: newLeft, y: newTop });
            }
        };

        const handleMouseUp = () => {
            if (isDragging || isResizing) {
                setIsDragging(false);
                setIsResizing(false);
                resizeType.current = null;
                if (modalRef.current) modalRef.current.style.transition = '';
            }
        };

        if (isDragging || isResizing) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
        }

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isDragging, isResizing]);

    useEffect(() => {
        if (showEditModal && modalRef.current && !isModalInitialized) {
            setTimeout(() => { centerModal(); setWidthMode('wide'); setIsModalInitialized(true); }, 50);
        }
        if (!showEditModal) setIsModalInitialized(false);
    }, [showEditModal, centerModal, setWidthMode, isModalInitialized]);

    // ============================================
    // PRINT QR CODE FUNCTION - 50mm x 25mm Label
    // ============================================
    // Updated printQRCodeForRecord - Creates working short URLs

const printQRCodeForRecord = async (record) => {
    if (!record || !record.id) {
        showToast('error', 'Invalid record for QR code printing');
        return;
    }

    try {
        showToast('info', 'Generating QR Code...');

        const shopId = currentShop?.shop_id;
        
        if (!shopId) {
            showToast('error', 'No shop selected');
            return;
        }

        let qrUrl = '';
        
        try {
            const response = await fetch(
                `https://ourzestapp.online/oz_backend/mechanics_module/tiny.php?record_id=${record.id}&shop_id=${shopId}`,
                {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' }
                }
            );
            
            const data = await response.json();
            
            if (data.status === 'success') {
                qrUrl = data.data.alt_url && data.data.alt_length < data.data.url_length 
                    ? data.data.alt_url 
                    : data.data.short_url;
            } else {
                qrUrl = `https://ourzestapp.online/oz_backend/mechanics_module/s.php?id=${record.id}&s=${shopId}`;
            }
        } catch (error) {
            qrUrl = `https://ourzestapp.online/oz_backend/mechanics_module/s.php?id=${record.id}&s=${shopId}`;
        }

        const qrCodeDataUrl = await QRCode.toDataURL(qrUrl, {
            errorCorrectionLevel: 'L',
            margin: 0,
            width: 300,
            color: { dark: '#000000', light: '#ffffff' }
        });

        const businessName = localBusinessInfo?.businessname || currentShop?.shop_name || 'Service';

        const printWindow = window.open('', '_blank', 'width=400,height=200');
        if (!printWindow) {
            showToast('error', 'Pop-up blocked. Please allow pop-ups.');
            return;
        }

        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <style>
                    @page { size: 50mm 25mm; margin: 0; }
                    * { margin: 0; padding: 0; }
                    body {
                        width: 50mm; height: 25mm;
                        display: flex; align-items: center;
                        font-family: Arial, sans-serif;
                    }
                    img {
                        width: 21mm; height: 21mm;
                        margin: 0 2mm 0 2mm;
                        image-rendering: pixelated;
                    }
                    span {
                        font-size: 10pt; font-weight: 700;
                        color: #000; line-height: 1;
                    }
                </style>
            </head>
            <body>
                <img src="${qrCodeDataUrl}">
                <span>${escapeHtml(businessName)}</span>
                <script>
                    window.onload=function(){
                        setTimeout(function(){
                            window.print();
                            window.onafterprint=function(){window.close();};
                        },100);
                    };
                <\/script>
            </body>
            </html>
        `);

        printWindow.document.close();
        printWindow.focus();
        showToast('success', 'QR label ready');

    } catch (error) {
        console.error('Error printing QR Code:', error);
        showToast('error', 'Error generating QR Code');
    }
};

    // Fetch oil records
    const fetchOilRecords = useCallback(async () => {
        if (!user || !user.username) {
            if (isMountedRef.current) {
                showToast('error', 'User information not available');
                setLoading(false);
            }
            return;
        }
        if (!currentShop) {
            if (isMountedRef.current) {
                showToast('error', translations.noShopSelected || 'Please select a shop first');
                setLoading(false);
            }
            return;
        }
        if (isMountedRef.current) setLoading(true);
        try {
            const response = await fetch(OIL_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_records',
                    shop_id: currentShop.shop_id,
                    username: user.username
                })
            });
            const data = await response.json();
            if (isMountedRef.current) {
                if (data.status === 'success') {
                    setOilRecords(data.data || []);
                    setFilteredOilRecords(data.data || []);
                } else {
                    showToast('error', data.message || translations.networkError || 'Network error occurred');
                }
            }
        } catch (error) {
            console.error('Error fetching oil records:', error);
            if (isMountedRef.current) showToast('error', translations.networkError || 'Network error occurred');
        } finally {
            if (isMountedRef.current) setLoading(false);
        }
    }, [user, currentShop, translations, showToast]);

    const fetchAvailableShops = useCallback(async () => {
        if (!user) return;
        setLoadingShops(true);
        try {
            const shopsData = await getShopsForSwitch();
            if (isMountedRef.current) setAvailableShops(shopsData.shops || []);
        } catch (error) {
            console.error('Error loading shops:', error);
            if (isMountedRef.current) setAvailableShops([]);
        } finally {
            if (isMountedRef.current) setLoadingShops(false);
        }
    }, [user, getShopsForSwitch]);

    useEffect(() => {
        if (user && user.username && currentShop) {
            fetchOilRecords();
            fetchAvailableShops();
        } else if (user && user.username && !currentShop) {
            setLoading(false);
        } else if (!user) {
            setLoading(false);
        }
    }, [user, currentShop?.shop_id]);

    const handleSwitchShop = useCallback(async (shop) => {
        try {
            const success = await switchShop(shop.shop_id, shop.shop_name, shop.shop_code);
            if (success) {
                showToast('success', 'Shop switched successfully');
                setCurrentPage(1);
                setShowShopSelector(false);
            } else {
                showToast('error', 'Failed to switch shop');
            }
        } catch (error) {
            console.error('Error switching shop:', error);
            showToast('error', 'Failed to switch shop');
        }
    }, [switchShop, showToast]);

    // ============================================
    // PRINT RECEIPT FUNCTION
    // ============================================
    const handlePrintReceipt = async (record) => {
        // ... (same as before - keep your existing receipt printing code)
        // For brevity, I'm showing a simplified version here
        // You should keep your full receipt printing code
        showToast('info', 'Receipt printing...');
    };

    const applyFilters = useCallback(() => {
        let filtered = [...oilRecords];

        if (searchTerm.trim()) {
            const term = searchTerm.toLowerCase();
            filtered = filtered.filter(record =>
                record.mobchange_number?.toLowerCase().includes(term) ||
                record.customer_name?.toLowerCase().includes(term) ||
                record.car_model?.toLowerCase().includes(term) ||
                record.car_number_plate?.toLowerCase().includes(term) ||
                record.customer_phone?.toLowerCase().includes(term)
            );
        }

        if (statusFilter && statusFilter !== '') {
            filtered = filtered.filter(record => record.status === statusFilter);
        }

        if (paymentFilter && paymentFilter !== '') {
            filtered = filtered.filter(record => record.payment_status === paymentFilter);
        }

        if (startDate) {
            filtered = filtered.filter(record => record.date >= startDate);
        }

        if (endDate) {
            filtered = filtered.filter(record => record.date <= endDate);
        }

        setFilteredOilRecords(filtered);
        setCurrentPage(1);
    }, [oilRecords, searchTerm, statusFilter, paymentFilter, startDate, endDate]);

    useEffect(() => { applyFilters(); }, [applyFilters]);

    const resetFilters = useCallback(() => {
        setStatusFilter('');
        setPaymentFilter('');
        setStartDate('');
        setEndDate('');
        setSearchTerm('');
    }, []);

    const formatDate = useCallback((dateString) => {
        if (!dateString) return '-';
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return dateString;
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        } catch { return dateString; }
    }, []);

    const formatCurrency = (amount) => {
        if (!amount && amount !== 0) return 'Rs. 0.00';
        return `Rs. ${parseFloat(amount).toFixed(2)}`;
    };

    const getStatusBadge = (status) => {
        const statusConfig = {
            pending: { icon: faHourglassHalf, color: '#f59e0b', bg: '#fef3c7' },
            in_progress: { icon: faClock, color: '#3b82f6', bg: '#dbeafe' },
            completed: { icon: faCheck, color: '#10b981', bg: '#d1fae5' },
            cancelled: { icon: faBan, color: '#ef4444', bg: '#fee2e2' }
        };
        const config = statusConfig[status] || statusConfig.pending;
        const label = translations[status] || status;
        return (
            <span style={{ backgroundColor: config.bg, color: config.color, display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '4px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: '500' }}>
                <FontAwesomeIcon icon={config.icon} size="xs" />
                {label}
            </span>
        );
    };

    const getPaymentStatusBadge = (status, paidAmount, grandTotal) => {
        const statusConfig = {
            paid: { icon: faCheckCircle, color: '#10b981', bg: '#d1fae5' },
            partial: { icon: faClock, color: '#f59e0b', bg: '#fef3c7' },
            unpaid: { icon: faExclamationTriangle, color: '#ef4444', bg: '#fee2e2' }
        };
        const config = statusConfig[status] || statusConfig.unpaid;
        const label = translations[status] || status;
        return (
            <span style={{ backgroundColor: config.bg, color: config.color, display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '4px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: '500' }}>
                <FontAwesomeIcon icon={config.icon} size="xs" />
                {label}
            </span>
        );
    };

    const currentDateGlobal = () => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    };

    const getRowsPerPage = useCallback(() => {
        if (pdfOrientation === 'landscape') {
            return 20;
        }
        return 15;
    }, [pdfOrientation]);

    const totalOilRecordsCount = filteredOilRecords.length;
    const totalRevenue = filteredOilRecords.reduce((sum, s) => sum + (parseFloat(s.grand_total) || 0), 0);
    const totalPaid = filteredOilRecords.reduce((sum, s) => sum + (parseFloat(s.paid_amount) || 0), 0);
    const totalOutstanding = totalRevenue - totalPaid;

    const pagination = useMemo(() => {
        const totalPages = Math.ceil(filteredOilRecords.length / itemsPerPage);
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentOilRecords = filteredOilRecords.slice(startIndex, endIndex);
        return { totalPages, startIndex, endIndex, currentOilRecords };
    }, [filteredOilRecords, currentPage, itemsPerPage]);

    // PDF EXPORT FUNCTION (keep your existing one)
    const exportToPDF = useCallback(async () => {
        // ... keep your existing PDF export code
        showToast('info', 'PDF export...');
    }, []);

    const handleView = useCallback((record) => { setSelectedOilRecord(record); setShowViewModal(true); }, []);
    const handleEdit = useCallback((record) => {
        setSelectedOilRecord(record);
        setEditFormData({
            oil_number: record.mobchange_number || '',
            customer_name: record.customer_name || '',
            customer_phone: record.customer_phone || '',
            car_model: record.car_model || '',
            car_number_plate: record.car_number_plate || '',
            odometer_reading: record.odometer_reading || '',
            mobo_oil_millage: record.mobo_oil_millage || '',
            next_change: record.next_change || '',
            date: record.date || '',
            total_amount: record.grand_total || '',
            paid_amount: record.paid_amount || '',
            status: record.status || 'pending',
            payment_status: record.payment_status || 'unpaid',
            payment_method: record.payment_method || 'cash',
            notes: record.notes || ''
        });
        setEditFormErrors({});
        setShowEditModal(true);
    }, []);

    const handleDeleteClick = useCallback((recordId) => {
        const record = oilRecords.find(r => r.id === recordId);
        if (!record) return;
        if (record.username !== user?.username) {
            showToast('error', 'You can only delete oil records you added');
            return;
        }
        setOilRecordToDelete(recordId);
        setShowDeleteModal(true);
    }, [oilRecords, user, showToast]);

    const handleDelete = useCallback(async () => {
        if (!oilRecordToDelete || !currentShop) return;
        const record = oilRecords.find(r => r.id === oilRecordToDelete);
        if (!record || record.username !== user?.username) {
            showToast('error', 'You can only delete your own oil records');
            setShowDeleteModal(false);
            setOilRecordToDelete(null);
            return;
        }
        try {
            const response = await fetch(OIL_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'delete',
                    mobchange_id: oilRecordToDelete,
                    username: user.username,
                    shop_id: currentShop.shop_id
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                showToast('success', 'Oil record deleted successfully');
                fetchOilRecords();
                setShowDeleteModal(false);
                setOilRecordToDelete(null);
            } else {
                showToast('error', data.message || 'Error deleting oil record');
            }
        } catch (error) {
            console.error('Error deleting oil record:', error);
            showToast('error', 'Error deleting oil record');
        }
    }, [oilRecordToDelete, currentShop, oilRecords, user, showToast, fetchOilRecords]);

    const handleUpdateOilRecord = useCallback(async (e) => {
        e.preventDefault();
        if (!selectedOilRecord || !currentShop) return;
        const errors = {};
        if (!editFormData.customer_name.trim()) errors.customer_name = 'Customer name is required';
        if (editFormData.customer_phone && !/^[\d\s\-\+\(\)]{10,15}$/.test(editFormData.customer_phone)) errors.customer_phone = 'Please enter a valid phone number';
        if (editFormData.paid_amount && isNaN(parseFloat(editFormData.paid_amount))) errors.paid_amount = 'Please enter a valid amount';
        if (Object.keys(errors).length > 0) { setEditFormErrors(errors); return; }
        setEditLoading(true);
        try {
            const response = await fetch(OIL_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'update',
                    mobchange_id: selectedOilRecord.id,
                    username: user.username,
                    shop_id: currentShop.shop_id,
                    customer_name: editFormData.customer_name,
                    customer_phone: editFormData.customer_phone,
                    car_model: editFormData.car_model,
                    car_number_plate: editFormData.car_number_plate,
                    odometer_reading: editFormData.odometer_reading,
                    mobo_oil_millage: editFormData.mobo_oil_millage,
                    next_change: editFormData.next_change,
                    date: editFormData.date,
                    total_amount: parseFloat(editFormData.total_amount) || 0,
                    paid_amount: parseFloat(editFormData.paid_amount) || 0,
                    status: editFormData.status,
                    payment_status: editFormData.payment_status,
                    payment_method: editFormData.payment_method,
                    notes: editFormData.notes
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                showToast('success', 'Oil record updated successfully');
                setShowEditModal(false);
                fetchOilRecords();
            } else {
                showToast('error', data.message || 'Error updating oil record');
            }
        } catch (error) {
            console.error('Error updating oil record:', error);
            showToast('error', 'Error updating oil record');
        } finally {
            setEditLoading(false);
        }
    }, [selectedOilRecord, currentShop, editFormData, user, showToast, fetchOilRecords]);

    const handlePageChange = useCallback((page) => { if (page >= 1 && page <= pagination.totalPages) setCurrentPage(page); }, [pagination.totalPages]);

    const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';

    return (
        <div className={`ozlistui-container ${isRTL ? 'ozlistui-rtl' : 'ozlistui-ltr'} ${darkMode ? 'ozlistui-dark' : ''}`}>
            <ToastNotification toast={toast} setToast={setToast} translations={translations} />

            <ShopSelectorModal
                isOpen={showShopSelector}
                onClose={() => setShowShopSelector(false)}
                shops={availableShops}
                currentShop={currentShop}
                onSelectShop={handleSwitchShop}
                translations={translations}
                loading={loadingShops}
            />

            <div className="ozlistui-sticky-header">
                <div className="ozlistui-header-bg-animation">
                    <div className="gradient-orb orb-1"></div>
                    <div className="gradient-orb orb-2"></div>
                    <div className="gradient-orb orb-3"></div>
                    <div className="gradient-orb orb-4"></div>
                    <div className="gradient-orb orb-5"></div>
                </div>
                <div className="ozlistui-header-content">
                    <div className="ozlistui-header-left">
                        <div className="ozlistui-header-title">
                            <h1>{translations.oilList || 'Oil Records List'}</h1>
                            <p>{translations.formDetails || 'All oil records are below'}</p>
                        </div>
                    </div>
                    <div className="ozlistui-header-right">
                        <button 
                            className="ozlistui-header-filter-btn"
                            onClick={() => setShowFilters(!showFilters)}
                            title={showFilters ? "Hide Filters" : "Show Filters"}
                        >
                            <FontAwesomeIcon icon={showFilters ? faEyeSlash : faFilter} />
                            <span>{showFilters ? "Hide Filters" : "Filters"}</span>
                        </button>
                        
                        {!currentShop && (
                            <button className="ozlistui-header-shop-btn" onClick={() => setShowShopSelector(true)}>
                                <FontAwesomeIcon icon={faExchangeAlt} />
                                <span>{translations.switchShop || 'Switch Shop'}</span>
                            </button>
                        )}
                    </div>
                </div>
            </div>

            {showFilters && (
                <div className="ozlistui-filters-section">
                    <div className="ozlistui-filters-row">
                        <div className="ozlistui-filter-group">
                            <div className="ozlistui-floating-wrapper">
                                <input
                                    type="text"
                                    id="searchFilter"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    placeholder=" "
                                />
                                <label htmlFor="searchFilter">
                                    <FontAwesomeIcon icon={faSearch} />
                                    {translations.searchFilter || 'Search'}
                                </label>
                            </div>
                        </div>

                        <CustomDropdown
                            label={translations.statusFilter || 'Status'}
                            icon={faTag}
                            value={statusFilter}
                            onChange={setStatusFilter}
                            options={statusOptions}
                            translations={translations}
                        />

                        <CustomDropdown
                            label={translations.paymentFilter || 'Payment Status'}
                            icon={faMoneyBill}
                            value={paymentFilter}
                            onChange={setPaymentFilter}
                            options={paymentOptions}
                            translations={translations}
                        />

                        <div className="ozlistui-filter-group">
                            <div className="ozlistui-floating-wrapper">
                                <input
                                    type="date"
                                    id="startDate"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    placeholder=" "
                                />
                                <label htmlFor="startDate">
                                    <FontAwesomeIcon icon={faCalendar} />
                                    {translations.startDate || 'Start Date'}
                                </label>
                            </div>
                        </div>

                        <div className="ozlistui-filter-group">
                            <div className="ozlistui-floating-wrapper">
                                <input
                                    type="date"
                                    id="endDate"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    placeholder=" "
                                />
                                <label htmlFor="endDate">
                                    <FontAwesomeIcon icon={faCalendar} />
                                    {translations.endDate || 'End Date'}
                                </label>
                            </div>
                        </div>

                        <CustomDropdown
                            label={translations.orientation || 'Orientation'}
                            icon={faFilePdf}
                            value={pdfOrientation}
                            onChange={setPdfOrientation}
                            options={pdfOrientationOptions}
                            translations={translations}
                        />

                        <CustomDropdown
                            label={translations.pageSize || 'Page Size'}
                            icon={faFilePdf}
                            value={pdfPageSize}
                            onChange={setPdfPageSize}
                            options={pdfPageSizeOptions}
                            translations={translations}
                        />

                        <div className="ozlistui-filter-group">
                            <button onClick={fetchOilRecords} className="ozlistui-refresh-btn" disabled={loading}>
                                <FontAwesomeIcon icon={faRefresh} />
                                <span className="ozlistui-btn-text">{translations.refresh || 'Refresh'}</span>
                            </button>
                        </div>

                        <div className="ozlistui-filter-group">
                            <button onClick={resetFilters} className="ozlistui-refresh-btn">
                                <FontAwesomeIcon icon={faTimes} />
                                <span className="ozlistui-btn-text">{translations.resetFilters || 'Reset'}</span>
                            </button>
                        </div>

                        <div className="ozlistui-filter-group">
                            <button
                                onClick={exportToPDF}
                                className="ozlistui-refresh-btn"
                                disabled={filteredOilRecords.length === 0 || pdfLoading}
                                style={{ background: 'linear-gradient(135deg, #dc2626, #b91c1c)', color: 'white' }}
                            >
                                {pdfLoading ? <div className="ozlistui-btn-spinner-small"></div> : <FontAwesomeIcon icon={faFilePdf} />}
                                <span className="ozlistui-btn-text">{translations.exportToPDF || 'Export PDF'}</span>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {loading ? (
                <div className="ozlistui-loading-container">
                    <div className="ozlistui-loading-spinner"></div>
                    <p>{translations.loadingUserData || 'Loading your oil record data...'}</p>
                </div>
            ) : !currentShop ? (
                <div className="ozlistui-no-shop-container">
                    <div className="ozlistui-no-shop-message">
                        <FontAwesomeIcon icon={faStore} />
                        <h3>{translations.noShopSelected || 'No Shop Selected'}</h3>
                        <p>{translations.selectShop || 'Please select a shop to view oil records'}</p>
                        <button className="ozlistui-btn ozlistui-btn-primary" onClick={() => setShowShopSelector(true)}>
                            <FontAwesomeIcon icon={faExchangeAlt} />
                            <span>{translations.switchShop || 'Switch Shop'}</span>
                        </button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="ozlistui-table-scroll">
                        <div className="ozlistui-table-container">
                            <div className="ozlistui-table-wrapper">
                                <table className="ozlistui-table">
                                    <thead>
                                        <tr>
                                            <th className="ozlistui-id-column ozlistui-centered-cell">{translations.serialNo || 'S.No'}</th>
                                            <th className="ozlistui-centered-cell">{translations.oilNumber || 'Oil No'}</th>
                                            <th className="ozlistui-centered-cell">{translations.customerName || 'Customer'}</th>
                                            <th className="ozlistui-centered-cell">{translations.carModel || 'Car Model'}</th>
                                            <th className="ozlistui-centered-cell">{translations.numberPlate || 'Plate'}</th>
                                            <th className="ozlistui-centered-cell">{translations.oilDate || 'Date'}</th>
                                            <th className="ozlistui-centered-cell">{translations.odometerReading || 'Odometer'}</th>
                                            <th className="ozlistui-centered-cell">{translations.moboOilMillage || 'Mobo Millage'}</th>
                                            <th className="ozlistui-centered-cell">{translations.nextChange || 'Next Change'}</th>
                                            <th className="ozlistui-centered-cell">{translations.totalAmount || 'Amount'}</th>
                                            <th className="ozlistui-centered-cell">{translations.paidAmount || 'Paid'}</th>
                                            <th className="ozlistui-centered-cell">{translations.balance || 'Balance'}</th>
                                            <th className="ozlistui-centered-cell">{translations.status || 'Status'}</th>
                                            <th className="ozlistui-centered-cell">{translations.paymentStatus || 'Payment'}</th>
                                            <th className="ozlistui-actions-column ozlistui-centered-cell">{translations.actions || 'Actions'}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pagination.currentOilRecords.map((record, index) => {
                                            const addedBy = record.username || '-';
                                            const isSelfAdded = addedBy === user?.username;
                                            const total = parseFloat(record.grand_total) || 0;
                                            const paid = parseFloat(record.paid_amount) || 0;
                                            const balance = total - paid;
                                            const nextChange = record.next_change ? `${record.next_change} KM` : '-';
                                            
                                            return (
                                                <tr key={record.id}>
                                                    <td className="ozlistui-id-cell ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{pagination.startIndex + index + 1}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text ozlistui-oil-number">{record.mobchange_number || '-'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{record.customer_name || '-'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{record.car_model || '-'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{record.car_number_plate || '-'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{formatDate(record.date)}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{record.odometer_reading || '-'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{record.mobo_oil_millage ? `${record.mobo_oil_millage} KM` : '-'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text" style={{ fontWeight: 'bold', color: 'var(--ozlistui-primary)' }}>{nextChange}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text ozlistui-amount">{formatCurrency(total)}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{formatCurrency(paid)}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text" style={{ color: balance > 0 ? '#dc2626' : '#10b981', fontWeight: '500' }}>{formatCurrency(balance)}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        {getStatusBadge(record.status)}
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        {getPaymentStatusBadge(record.payment_status, paid, total)}
                                                    </td>
                                                    <td className="ozlistui-actions-cell ozlistui-centered-cell">
                                                        <div className="ozlistui-actions-content">
                                                            {/* QR Code Print Button */}
                                                            <button 
                                                                onClick={() => printQRCodeForRecord(record)} 
                                                                className="ozlistui-action-btn ozlistui-qr-btn" 
                                                                title={translations.qrCode || 'Print QR Code'}
                                                            >
                                                                <FontAwesomeIcon icon={faQrcode} />
                                                            </button>
                                                            
                                                            {/* Print Receipt Button */}
                                                            <button onClick={() => handlePrintReceipt(record)} className="ozlistui-action-btn ozlistui-print-btn" title={translations.print || 'Print Receipt'}>
                                                                <FontAwesomeIcon icon={faPrint} />
                                                            </button>
                                                            
                                                            {/* Edit Button */}
                                                            <button onClick={() => handleEdit(record)} className="ozlistui-action-btn ozlistui-edit-btn" title={translations.edit || 'Edit'}>
                                                                <FontAwesomeIcon icon={faEdit} />
                                                            </button>
                                                            
                                                            {/* Delete Button */}
                                                            <button onClick={() => handleDeleteClick(record.id)} className="ozlistui-action-btn ozlistui-delete-btn" title={translations.delete || 'Delete'} disabled={!isSelfAdded} style={{ opacity: isSelfAdded ? 1 : 0.5, cursor: isSelfAdded ? 'pointer' : 'not-allowed' }}>
                                                                <FontAwesomeIcon icon={faTrash} />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {filteredOilRecords.length > 0 && currentShop && (
                        <div className="ozlistui-pagination">
                            <div className="ozlistui-pagination-info">
                                <span>{translations.showing || 'Showing'} {pagination.startIndex + 1} {translations.of || 'of'} {filteredOilRecords.length} {translations.oilRecords || 'oil records'}</span>
                            </div>
                            <div className="ozlistui-pagination-controls">
                                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="ozlistui-pagination-btn">
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                    <span>{translations.previous || 'Previous'}</span>
                                </button>
                                <div className="ozlistui-page-numbers">
                                    {Array.from({ length: Math.min(5, pagination.totalPages) }, (_, i) => {
                                        let pageNum;
                                        if (pagination.totalPages <= 5) {
                                            pageNum = i + 1;
                                        } else if (currentPage <= 3) {
                                            pageNum = i + 1;
                                        } else if (currentPage >= pagination.totalPages - 2) {
                                            pageNum = pagination.totalPages - 4 + i;
                                        } else {
                                            pageNum = currentPage - 2 + i;
                                        }
                                        return (
                                            <button key={pageNum} onClick={() => handlePageChange(pageNum)} className={`ozlistui-page-number ${currentPage === pageNum ? 'ozlistui-active' : ''}`}>
                                                {pageNum}
                                            </button>
                                        );
                                    })}
                                </div>
                                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === pagination.totalPages} className="ozlistui-pagination-btn">
                                    <span>{translations.next || 'Next'}</span>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </div>
                        </div>
                    )}
                </>
            )}

            {/* View Modal */}
            {showViewModal && selectedOilRecord && (
                <div className="ozlistui-modal-overlay" onClick={(e) => e.stopPropagation()}>
                    <div className="ozlistui-modal-content ozlistui-view-modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="ozlistui-modal-header">
                            <div className="ozlistui-modal-icon"><FontAwesomeIcon icon={faOilCan} /></div>
                            <div className="ozlistui-modal-title">
                                <h3>{translations.oilDetails || 'Oil Record Details'}</h3>
                                <span className="ozlistui-supplier-number-badge">#{selectedOilRecord.mobchange_number}</span>
                            </div>
                            <button className="ozlistui-close-btn" onClick={() => setShowViewModal(false)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <div className="ozlistui-modal-body ozlistui-view-modal-body">
                            <div className="ozlistui-view-section">
                                <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faOilCan} />Oil Record Summary</h4>
                                <div className="ozlistui-view-grid">
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.oilNumber || 'Oil Record Number'}:</span><span className="ozlistui-view-value">{selectedOilRecord.mobchange_number || '-'}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.oilDate || 'Oil Change Date'}:</span><span className="ozlistui-view-value">{formatDate(selectedOilRecord.date)}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.status || 'Status'}:</span><span className="ozlistui-view-value">{getStatusBadge(selectedOilRecord.status)}</span></div>
                                </div>
                            </div>
                            <div className="ozlistui-view-section">
                                <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faUser} />{translations.contactInfo || 'Contact Information'}</h4>
                                <div className="ozlistui-view-grid">
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.customerName || 'Customer Name'}:</span><span className="ozlistui-view-value">{selectedOilRecord.customer_name || '-'}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.customerPhone || 'Phone'}:</span><span className="ozlistui-view-value">{selectedOilRecord.customer_phone || '-'}</span></div>
                                </div>
                            </div>
                            <div className="ozlistui-view-section">
                                <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faCar} />{translations.vehicleInfo || 'Vehicle Information'}</h4>
                                <div className="ozlistui-view-grid">
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.carModel || 'Car Model'}:</span><span className="ozlistui-view-value">{selectedOilRecord.car_model || '-'}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.numberPlate || 'Number Plate'}:</span><span className="ozlistui-view-value">{selectedOilRecord.car_number_plate || '-'}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.odometerReading || 'Odometer Reading'}:</span><span className="ozlistui-view-value">{selectedOilRecord.odometer_reading || '-'}</span></div>
                                </div>
                            </div>
                            <div className="ozlistui-view-section">
                                <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faRoad} />Oil Change Schedule</h4>
                                <div className="ozlistui-view-grid">
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.moboOilMillage || 'Mobo Oil Millage'}:</span><span className="ozlistui-view-value">{selectedOilRecord.mobo_oil_millage ? `${selectedOilRecord.mobo_oil_millage} KM` : '-'}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.nextChange || 'Next Change'}:</span><span className="ozlistui-view-value" style={{ fontWeight: 'bold', color: 'var(--ozlistui-primary)' }}>{selectedOilRecord.next_change ? `${selectedOilRecord.next_change} KM` : '-'}</span></div>
                                </div>
                            </div>
                            <div className="ozlistui-view-section">
                                <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faCalculator} />{translations.financialSummary || 'Financial Summary'}</h4>
                                <div className="ozlistui-financial-grid">
                                    <div className="ozlistui-view-row ozlistui-grand-total"><span className="ozlistui-view-label">{translations.totalAmount || 'Total Amount'}:</span><span className="ozlistui-view-value">{formatCurrency(selectedOilRecord.grand_total)}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.paidAmount || 'Paid Amount'}:</span><span className="ozlistui-view-value">{formatCurrency(selectedOilRecord.paid_amount)}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.balance || 'Balance'}:</span><span className="ozlistui-view-value" style={{ color: ((selectedOilRecord.grand_total || 0) - (selectedOilRecord.paid_amount || 0)) > 0 ? '#dc2626' : '#10b981' }}>{formatCurrency((selectedOilRecord.grand_total || 0) - (selectedOilRecord.paid_amount || 0))}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.paymentMethod || 'Payment Method'}:</span><span className="ozlistui-view-value">{selectedOilRecord.payment_method || '-'}</span></div>
                                </div>
                            </div>
                            {selectedOilRecord.notes && (
                                <div className="ozlistui-view-section">
                                    <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faStickyNote} />{translations.notes || 'Notes'}</h4>
                                    <div className="ozlistui-remarks-box">{selectedOilRecord.notes}</div>
                                </div>
                            )}
                            <div className="ozlistui-view-section ozlistui-metadata-section">
                                <div className="ozlistui-view-grid">
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.addedBy || 'Added By'}:</span><span className="ozlistui-view-value"><span className="ozlistui-added-by-badge">{selectedOilRecord.username || '-'}</span></span></div>
                                </div>
                            </div>
                        </div>
                        <div className="ozlistui-modal-footer">
                            <button className="ozlistui-btn ozlistui-btn-secondary" onClick={() => setShowViewModal(false)}>{translations.close || 'Close'}</button>
                            <button className="ozlistui-btn ozlistui-btn-primary" onClick={() => { setShowViewModal(false); handleEdit(selectedOilRecord); }}>
                                <FontAwesomeIcon icon={faEdit} />
                                {translations.edit || 'Edit'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Modal */}
            {showEditModal && selectedOilRecord && (
                <div className="ozlistui-modal-overlay" onClick={(e) => e.stopPropagation()}>
                    <div
                        ref={modalRef}
                        className="ozlistui-modal-content ozlistui-edit-modal-content"
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            position: 'fixed',
                            left: modalPosition.x || '50%',
                            top: modalPosition.y || '50%',
                            transform: modalPosition.x === 0 && modalPosition.y === 0 ? 'translate(-50%, -50%)' : 'none',
                            width: modalSize.width,
                            minWidth: '350px',
                            maxWidth: '95vw',
                            maxHeight: '85vh'
                        }}
                    >
                        <div className="ozlistui-resize-handle-top" onMouseDown={(e) => startResize(e, 'n')}></div>
                        <div className="ozlistui-resize-handle-bottom" onMouseDown={(e) => startResize(e, 's')}></div>
                        <div className="ozlistui-resize-handle-left" onMouseDown={(e) => startResize(e, 'w')}></div>
                        <div className="ozlistui-resize-handle-right" onMouseDown={(e) => startResize(e, 'e')}></div>
                        <div className="ozlistui-resize-handle-nw" onMouseDown={(e) => startResize(e, 'nw')}></div>
                        <div className="ozlistui-resize-handle-ne" onMouseDown={(e) => startResize(e, 'ne')}></div>
                        <div className="ozlistui-resize-handle-sw" onMouseDown={(e) => startResize(e, 'sw')}></div>
                        <div className="ozlistui-resize-handle-se" onMouseDown={(e) => startResize(e, 'se')}></div>

                        <div className="ozlistui-modal-header" onMouseDown={startDrag}>
                            <div className="ozlistui-modal-icon"><FontAwesomeIcon icon={faEdit} /></div>
                            <div className="ozlistui-modal-title">
                                <h3>{translations.editOilRecord || 'Edit Oil Record'}</h3>
                                <span className="ozlistui-supplier-number-badge">#{selectedOilRecord.mobchange_number}</span>
                            </div>
                            <div className="ozlistui-width-control-group">
                                {Object.entries(widthModes).map(([key, mode]) => (
                                    <button key={key} className={`ozlistui-width-btn ${currentWidthMode === key ? 'ozlistui-active' : ''}`} onClick={() => setWidthMode(key)} title={mode.label}>
                                        <FontAwesomeIcon icon={mode.icon} />
                                    </button>
                                ))}
                            </div>
                            <button className="ozlistui-close-btn" onClick={() => setShowEditModal(false)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        <form onSubmit={handleUpdateOilRecord}>
                            <div className="ozlistui-modal-body">
                                <div className="ozlistui-form-grid">
                                    <div className={`ozlistui-form-group ${editFormErrors.customer_name ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_customer_name"
                                                name="customer_name"
                                                value={editFormData.customer_name}
                                                onChange={(e) => setEditFormData({ ...editFormData, customer_name: e.target.value })}
                                                placeholder=" "
                                                className={editFormErrors.customer_name ? 'ozlistui-error' : ''}
                                            />
                                            <label htmlFor="edit_customer_name">
                                                <FontAwesomeIcon icon={faUser} />
                                                {translations.customerName || 'Customer Name'} <span className="ozlistui-required">*</span>
                                            </label>
                                        </div>
                                        {editFormErrors.customer_name && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.customer_name}
                                            </div>
                                        )}
                                    </div>

                                    <div className={`ozlistui-form-group ${editFormErrors.customer_phone ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="tel"
                                                id="edit_customer_phone"
                                                name="customer_phone"
                                                value={editFormData.customer_phone}
                                                onChange={(e) => setEditFormData({ ...editFormData, customer_phone: e.target.value })}
                                                placeholder=" "
                                                dir="ltr"
                                            />
                                            <label htmlFor="edit_customer_phone">
                                                <FontAwesomeIcon icon={faPhone} />
                                                {translations.customerPhone || 'Phone'}
                                                <span> ({translations.optional || 'Optional'})</span>
                                            </label>
                                        </div>
                                        {editFormErrors.customer_phone && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.customer_phone}
                                            </div>
                                        )}
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_car_model"
                                                name="car_model"
                                                value={editFormData.car_model}
                                                onChange={(e) => setEditFormData({ ...editFormData, car_model: e.target.value })}
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_car_model">
                                                <FontAwesomeIcon icon={faCar} />
                                                {translations.carModel || 'Car Model'}
                                                <span> ({translations.optional || 'Optional'})</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_car_number_plate"
                                                name="car_number_plate"
                                                value={editFormData.car_number_plate}
                                                onChange={(e) => setEditFormData({ ...editFormData, car_number_plate: e.target.value })}
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_car_number_plate">
                                                <FontAwesomeIcon icon={faCar} />
                                                {translations.numberPlate || 'Number Plate'}
                                                <span> ({translations.optional || 'Optional'})</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_odometer_reading"
                                                name="odometer_reading"
                                                value={editFormData.odometer_reading}
                                                onChange={(e) => setEditFormData({ ...editFormData, odometer_reading: e.target.value })}
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_odometer_reading">
                                                <FontAwesomeIcon icon={faTachometerAlt} />
                                                {translations.odometerReading || 'Odometer Reading'}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_mobo_oil_millage"
                                                name="mobo_oil_millage"
                                                value={editFormData.mobo_oil_millage}
                                                onChange={(e) => {
                                                    const millage = e.target.value;
                                                    const odometer = editFormData.odometer_reading;
                                                    let nextChange = '';
                                                    if (odometer && millage) {
                                                        nextChange = (parseFloat(odometer) + parseFloat(millage)).toString();
                                                    }
                                                    setEditFormData({ 
                                                        ...editFormData, 
                                                        mobo_oil_millage: millage,
                                                        next_change: nextChange
                                                    });
                                                }}
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_mobo_oil_millage">
                                                <FontAwesomeIcon icon={faRoad} />
                                                {translations.moboOilMillage || 'Mobo Oil Millage'}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_next_change"
                                                name="next_change"
                                                value={editFormData.next_change}
                                                readOnly
                                                placeholder=" "
                                                style={{ backgroundColor: 'var(--ozlistui-surface)', fontWeight: 'bold' }}
                                            />
                                            <label htmlFor="edit_next_change">
                                                <FontAwesomeIcon icon={faCalendarCheck} />
                                                {translations.nextChange || 'Next Change'}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="date"
                                                id="edit_date"
                                                name="date"
                                                value={editFormData.date}
                                                onChange={(e) => setEditFormData({ ...editFormData, date: e.target.value })}
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_date">
                                                <FontAwesomeIcon icon={faCalendar} />
                                                {translations.oilDate || 'Oil Change Date'}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                id="edit_total_amount"
                                                name="total_amount"
                                                value={editFormData.total_amount}
                                                readOnly
                                                placeholder=" "
                                                step="0.01"
                                            />
                                            <label htmlFor="edit_total_amount">
                                                <FontAwesomeIcon icon={faMoneyBill} />
                                                {translations.totalAmount || 'Total Amount'}
                                            </label>
                                        </div>
                                    </div>

                                    <div className={`ozlistui-form-group ${editFormErrors.paid_amount ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                id="edit_paid_amount"
                                                name="paid_amount"
                                                value={editFormData.paid_amount}
                                                onChange={(e) => setEditFormData({ ...editFormData, paid_amount: e.target.value })}
                                                placeholder=" "
                                                step="0.01"
                                                min="0"
                                            />
                                            <label htmlFor="edit_paid_amount">
                                                <FontAwesomeIcon icon={faMoneyBill} />
                                                {translations.paidAmount || 'Paid Amount'}
                                            </label>
                                        </div>
                                        {editFormErrors.paid_amount && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.paid_amount}
                                            </div>
                                        )}
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <select
                                                id="edit_status"
                                                name="status"
                                                value={editFormData.status}
                                                onChange={(e) => setEditFormData({ ...editFormData, status: e.target.value })}
                                            >
                                                <option value="pending">{translations.pending || 'Pending'}</option>
                                                <option value="in_progress">{translations.inProgress || 'In Progress'}</option>
                                                <option value="completed">{translations.completed || 'Completed'}</option>
                                                <option value="cancelled">{translations.cancelled || 'Cancelled'}</option>
                                            </select>
                                            <label htmlFor="edit_status">
                                                <FontAwesomeIcon icon={faClock} />
                                                {translations.status || 'Status'}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <select
                                                id="edit_payment_status"
                                                name="payment_status"
                                                value={editFormData.payment_status}
                                                onChange={(e) => setEditFormData({ ...editFormData, payment_status: e.target.value })}
                                            >
                                                <option value="unpaid">{translations.unpaid || 'Unpaid'}</option>
                                                <option value="partial">{translations.partial || 'Partial'}</option>
                                                <option value="paid">{translations.paid || 'Paid'}</option>
                                            </select>
                                            <label htmlFor="edit_payment_status">
                                                <FontAwesomeIcon icon={faMoneyBill} />
                                                {translations.paymentStatus || 'Payment Status'}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <select
                                                id="edit_payment_method"
                                                name="payment_method"
                                                value={editFormData.payment_method}
                                                onChange={(e) => setEditFormData({ ...editFormData, payment_method: e.target.value })}
                                            >
                                                <option value="cash">{translations.cash || 'Cash'}</option>
                                                <option value="card">{translations.card || 'Card'}</option>
                                                <option value="upi">{translations.upi || 'UPI'}</option>
                                                <option value="bank_transfer">Bank Transfer</option>
                                            </select>
                                            <label htmlFor="edit_payment_method">
                                                <FontAwesomeIcon icon={faCreditCard} />
                                                {translations.paymentMethod || 'Payment Method'}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group ozlistui-full-width">
                                        <div className="ozlistui-input-wrapper">
                                            <textarea
                                                id="edit_notes"
                                                name="notes"
                                                value={editFormData.notes}
                                                onChange={(e) => setEditFormData({ ...editFormData, notes: e.target.value })}
                                                rows="3"
                                                placeholder=" "
                                            ></textarea>
                                            <label htmlFor="edit_notes">
                                                <FontAwesomeIcon icon={faStickyNote} />
                                                {translations.notes || 'Notes'}
                                                <span> ({translations.optional || 'Optional'})</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="ozlistui-modal-footer">
                                <button type="button" className="ozlistui-btn ozlistui-btn-secondary" onClick={() => setShowEditModal(false)}>
                                    <FontAwesomeIcon icon={faTimes} />
                                    {translations.cancel || 'Cancel'}
                                </button>
                                <button type="submit" className="ozlistui-btn ozlistui-btn-primary" disabled={editLoading}>
                                    {editLoading ? (
                                        <>
                                            <div className="ozlistui-btn-spinner"></div>
                                            <span>{translations.updating || 'Updating...'}</span>
                                        </>
                                    ) : (
                                        <>
                                            <FontAwesomeIcon icon={faSave} />
                                            <span>{translations.saveChanges || 'Save Changes'}</span>
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Delete Confirmation Modal */}
            {showDeleteModal && (
                <div className="ozlistui-modal-overlay" onClick={(e) => e.stopPropagation()}>
                    <div className="ozlistui-modal-content ozlistui-delete-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="ozlistui-modal-header ozlistui-delete-header">
                            <div className="ozlistui-modal-icon"><FontAwesomeIcon icon={faExclamationTriangle} /></div>
                            <div className="ozlistui-modal-title"><h3>{translations.confirmDelete || 'Confirm Delete'}</h3></div>
                            <button className="ozlistui-close-btn" onClick={() => setShowDeleteModal(false)}><FontAwesomeIcon icon={faTimes} /></button>
                        </div>
                        <div className="ozlistui-modal-body">
                            <div className="ozlistui-delete-message">
                                <p>{translations.deleteMessage || 'Are you sure you want to delete this oil record?'}</p>
                                <p><FontAwesomeIcon icon={faExclamationTriangle} /> {translations.deleteWarning || 'This action cannot be undone.'}</p>
                            </div>
                        </div>
                        <div className="ozlistui-modal-footer">
                            <button type="button" className="ozlistui-btn ozlistui-btn-secondary" onClick={() => setShowDeleteModal(false)}><FontAwesomeIcon icon={faTimes} />{translations.noCancel || 'No, Cancel'}</button>
                            <button type="button" className="ozlistui-btn ozlistui-btn-delete" onClick={handleDelete}><FontAwesomeIcon icon={faTrash} />{translations.yesDelete || 'Yes, Delete'}</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default OilList;